/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoPickTicketInput = {
    clientMutationId?: string | null;
    slug: string;
};
export type TicketShowPickMutationVariables = {
    input: infoPickTicketInput;
};
export type TicketShowPickMutationResponse = {
    readonly infoPickTicket: {
        readonly clientMutationId: string | null;
    } | null;
};
export type TicketShowPickMutation = {
    readonly response: TicketShowPickMutationResponse;
    readonly variables: TicketShowPickMutationVariables;
};



/*
mutation TicketShowPickMutation(
  $input: infoPickTicketInput!
) {
  infoPickTicket(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoPickTicketPayload",
    "kind": "LinkedField",
    "name": "infoPickTicket",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TicketShowPickMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TicketShowPickMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e0d8c2a737ee2bda6e50dc3999b248a2",
    "id": null,
    "metadata": {},
    "name": "TicketShowPickMutation",
    "operationKind": "mutation",
    "text": "mutation TicketShowPickMutation(\n  $input: infoPickTicketInput!\n) {\n  infoPickTicket(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '3c5198b1c1f4ac1f7a31222ee1e9e100';
export default node;
